import { SebasMark } from "@/components/brand/SebasMark";
import { authClient } from "@/lib/auth";
import { SignInPage } from "@/routes/SignInPage";

/**
 * Gates the app on a session.
 *
 * Renders a brand-consistent hold while the session resolves rather than
 * flashing the sign-in screen at an already-authenticated user on every load.
 */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { data: session, isPending } = authClient.useSession();

  if (isPending) {
    return (
      <div className="grid min-h-dvh place-items-center bg-surface">
        <SebasMark className="h-10 w-10 animate-pulse text-ink-faint" title="Loading Sebas" />
      </div>
    );
  }

  if (!session) return <SignInPage />;

  return <>{children}</>;
}
